<div class="bz-table">
  <div
    class="bz-table__outer"
    [class]="tableClass()"
    [style.--bz-table-row-height]="rowHeightPx()"
    [style.--bz-table-header-height]="headerHeightPx()"
    [hidden]="hideWhenEmpty() && showEmptyState()"
    bzTableScrollSync
  >
    <div
      class="header-container"
      [bzTableColumnManager]="uniqueId()"
      [resizable]="resizable()"
      [defaultWidths]="defaultWidths()"
      [settings]="settings()"
      (settingsChange)="onSettingsChange($event)"
    >
      <div class="table-inner-wrapper">
        <div class="tr sticky-header">
          @if (headerDef()) {
            <ng-container [ngTemplateOutlet]="headerDef()!.templateRef" />
          }
        </div>
      </div>
    </div>

    <cdk-virtual-scroll-viewport
      class="body-container"
      [itemSize]="resolvedRowHeight()"
      (scroll)="onBodyScroll()"
      (mouseover)="onBodyMouseOver($event)"
    >
      <div class="table-inner-wrapper">
        <!--
          templateCacheSize is 0 on purpose. CDK's default of 20 detaches row views
          without destroying them, so ngOnDestroy never runs and hover overlays that
          park themselves on document.body (ngbTooltip container="body") stay after
          the row is gone. md-virtual-repeat did not cache views this way.
        -->
        <ng-container *cdkVirtualFor="let item of items(); let index = index; trackBy: trackByFn; templateCacheSize: 0">
          @if (rowDef()) {
            <ng-container
              [ngTemplateOutlet]="rowDef()!.templateRef"
              [ngTemplateOutletContext]="{ $implicit: item, index: index }"
            />
          }
        </ng-container>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>

  @if (showEmptyState()) {
    <div class="bz-table__empty">
      <ng-content select="[bzTableEmptyState]" />
    </div>
  }
</div>
